var counter = 1;
export default function PristineSeekbarFix(element) {
    var progressColor = '#401a96';
    var trackColor = '#d8d8d8';

    var sheet = document.head.appendChild(document.createElement('style')).sheet;
    var elementCounter = counter;
    counter++;

    var update = function() {
        var value = element.value;
        var min = element.min || 0;
        var max = element.max || 100;
        var percent = ((value - min) / (max - min)) * 100;
        var percentEpsilon = percent + 0.0000001;

        if (sheet.rules.length > 0) {
            sheet.removeRule(0);
        }


        var rule = '[data-seekbar-fix="' + elementCounter + '"]::-webkit-slider-runnable-track { background: linear-gradient(to right, ';
        rule += progressColor + ', ';
        rule += progressColor + ' ' + percent + '%, ';
        rule += trackColor + ' ' + percentEpsilon+'%, ';
        rule += trackColor;
        rule += ') !important; }';


        sheet.insertRule(rule, 0);
    };
    update();

    element.dataset.seekbarFix = elementCounter;
    element.addEventListener('input', update);

    element.addEventListener('seekbar.update', update);
}



// WEBPACK FOOTER //
// ./src/standalone/seekbar-fix.js